"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigCheckList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var react_window_1 = require("react-window");
var react_virtualized_auto_sizer_1 = __importDefault(require("react-virtualized-auto-sizer"));
var Checkbox_1 = require("../../atoms/Checkbox");
var Button_1 = require("../../atoms/Button");
var Legend_1 = require("../../atoms/Legend");
var useDebounce_1 = require("../../hooks/useDebounce");
exports.BigCheckList = react_1.default.memo(function (_a) {
    var _b, _c, _d;
    var idPrefix = _a.idPrefix, legend = _a.legend, _e = _a.options, options = _e === void 0 ? [] : _e, checkAll = _a.checkAll, onChange = _a.onChange, _f = _a.onClick, onClick = _f === void 0 ? function () { } : _f, _g = _a.enableSelectAll, enableSelectAll = _g === void 0 ? true : _g, _h = _a.enableClearSelections, enableClearSelections = _h === void 0 ? false : _h, _j = _a.enableApplySelections, enableApplySelections = _j === void 0 ? false : _j, _k = _a.onClearSelections, onClearSelections = _k === void 0 ? function () { } : _k, _l = _a.itemSize, itemSize = _l === void 0 ? 44 : _l, _m = _a.height, height = _m === void 0 ? 244 : _m;
    var _o = (0, react_1.useState)({
        checkAll: checkAll,
        options: options,
    }), state = _o[0], setState = _o[1];
    var debounce = (0, useDebounce_1.useDebounce)(onChange).debounce;
    var handleCheckAll = function (event) {
        var _a;
        var checkOptions = (_a = state.options) === null || _a === void 0 ? void 0 : _a.map(function (option) { return (__assign(__assign({}, option), { checked: !state.checkAll })); });
        var update = __assign(__assign({}, state), { checkAll: !state.checkAll, options: checkOptions });
        setState(update);
        debounce(event, update);
    };
    var handleCheck = function (event, option, index) {
        var checkOptions = __spreadArray([], state.options, true);
        var checked = !option.checked;
        // splice will update an array in place, so we copy the options first
        checkOptions.splice(index, 1, __assign(__assign({}, option), { checked: checked }));
        var update = __assign(__assign({}, state), { options: checkOptions });
        setState(update);
        if (!enableApplySelections) {
            debounce(event, update);
        }
    };
    var handleClearSelections = function (event) {
        var _a;
        var checkOptions = (_a = state.options) === null || _a === void 0 ? void 0 : _a.map(function (option) { return (__assign(__assign({}, option), { checked: false })); });
        var update = __assign(__assign({}, state), { checkAll: false, options: checkOptions });
        setState(update);
        onClick(event, update);
        if (onClearSelections && typeof onClearSelections === 'function') {
            onClearSelections(state);
        }
    };
    var handleApplySelections = function (event) {
        debounce(event, state);
    };
    var optionsLength = ((_b = state.options) === null || _b === void 0 ? void 0 : _b.length) || 0;
    var isIndeterminate = state.checkAll === true && ((_c = state.options) === null || _c === void 0 ? void 0 : _c.some(function (option) { return option.checked === false; }));
    var CheckOption = react_1.default.memo(function (_a) {
        var option = _a.option, index = _a.index;
        return ((0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { role: "menuitemcheckbox", label: option.label, id: "".concat(idPrefix).concat((option === null || option === void 0 ? void 0 : option.id) || option.label, "FilterCheckbox"), checked: option.checked, onChange: function (event) { return handleCheck(event, option, index); } }, "".concat(idPrefix).concat(option.label, "FilterCheckbox")));
    });
    var ClearSelectionsButton = react_1.default.memo(function () { return ((0, jsx_runtime_1.jsx)(Button_1.Button, __assign({ id: "link-clear-category-selections", "data-testid": "link-clear-category-selections", onClick: handleClearSelections, disableRipple: true, asLink: true, color: "secondary" }, { children: "Clear selections" }))); });
    var ApplySelectionsButton = react_1.default.memo(function () { return ((0, jsx_runtime_1.jsx)(Button_1.Button, __assign({ id: "link-apply-category-selections", "data-testid": "link-apply-category-selections", onClick: handleApplySelections, disableRipple: true, asLink: true }, { children: "Apply" }))); });
    var ActionButtons = react_1.default.memo(function () { return ((0, jsx_runtime_1.jsx)(core_1.Box, __assign({ position: "relative", style: { top: '12px' } }, { children: (0, jsx_runtime_1.jsxs)(core_1.Grid, __assign({ container: true }, { children: [enableClearSelections && ((0, jsx_runtime_1.jsx)(core_1.Grid, __assign({ container: true, xs: 8 }, { children: (0, jsx_runtime_1.jsx)(ClearSelectionsButton, {}) }))), enableApplySelections && ((0, jsx_runtime_1.jsx)(core_1.Grid, __assign({ container: true, xs: 4, justifyContent: "flex-end" }, { children: (0, jsx_runtime_1.jsx)(ApplySelectionsButton, {}) })))] })) }))); });
    // individual row used with AutoSizer and react window
    var Row = react_1.default.memo(function (_a) {
        var index = _a.index, style = _a.style;
        var option = state.options[index];
        return ((0, jsx_runtime_1.jsx)(core_1.Box, __assign({ style: __assign({}, style) }, { children: (0, jsx_runtime_1.jsx)(CheckOption, { option: option, index: index }, "".concat(option.label).concat(index)) })));
    });
    return ((0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ role: "group", display: "flex", flexDirection: "column", "data-testid": "big-checklist" }, { children: [(0, jsx_runtime_1.jsxs)(core_1.Box, { children: [legend && (0, jsx_runtime_1.jsx)(Legend_1.Legend, { children: legend }), enableSelectAll && ((0, jsx_runtime_1.jsx)(Checkbox_1.Checkbox, { role: "menuitemcheckbox", label: state.checkAll ? 'Unselect all' : 'Select all', id: "".concat(idPrefix, "SelectAllCheckbox"), checked: state.checkAll, indeterminate: isIndeterminate === true, onChange: function (event) { return handleCheckAll(event); }, disabled: !optionsLength }))] }), optionsLength <= 5 && ((0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ display: "flex", flexDirection: "column" }, { children: [(_d = state.options) === null || _d === void 0 ? void 0 : _d.map(function (option, index) { return (
                    // eslint-disable-next-line react/no-array-index-key
                    (0, jsx_runtime_1.jsx)(CheckOption, { option: option, index: index }, "".concat(option.label).concat(index))); }), (enableClearSelections || enableApplySelections) && (0, jsx_runtime_1.jsx)(ActionButtons, {})] }))), optionsLength > 5 && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(core_1.Box, __assign({ height: height, position: "relative" }, { children: (0, jsx_runtime_1.jsx)(react_virtualized_auto_sizer_1.default, { children: function (_a) {
                                var h = _a.height, width = _a.width;
                                return ((0, jsx_runtime_1.jsx)(react_window_1.FixedSizeList, __assign({ className: "List", height: h, itemCount: optionsLength, itemSize: itemSize, width: width }, { children: Row })));
                            } }) })), (enableClearSelections || enableApplySelections) && (0, jsx_runtime_1.jsx)(ActionButtons, {})] }))] })));
});
